(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['app/feature-config/FeatureConfigModel', 'services/demographicsFeatureConfigService'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var demographicsFeatureConfigService = require('./../urls').demographicsFeatureConfigService;
    module.exports = factory(require('./../feature-config/FeatureConfigModel'), demographicsFeatureConfigService);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (FeatureConfigModel, demographicsFeatureConfigService) {
  'use strict';

  /**
   * Model for demographics configuration information. Uses the DemographicsFeatureConfigService and corresponds to a DemographicsFeatureConfig
   *
   * @class DemographicsFeatureConfigModel
   * @extends FeatureConfigModel
   * @constructor
   */
  return new (FeatureConfigModel.extend({
    urlRoot: demographicsFeatureConfigService
  }))();
}));
